<app-loading *ngIf="!isLoaded"></app-loading>

<div *ngIf="isLoaded">
    <div *ngIf='errorMsg' class='text-center alert-text'>{{errorMsg}}</div>
    
    <div *ngIf='!errorMsg'>
        <div class="row">
            <div class="col-sm-12">

                <div class="action-menu pull-right" *ngIf="!loadingError">
                    <help-button (click)="displayHelpMessage=!displayHelpMessage"></help-button>
                </div>

                <!-- <div style='font-size:16px; margin-top:12px;'>
                    <span>Conference Detail</span>
                </div> -->
            </div>
        </div>

        <help-message [ngClass]="{'hide':!displayHelpMessage}"></help-message>

        <div class='row details-body'>
            <div class='col-sm-12'>

                <div *ngIf="!loadingError">

                    <div class='item'>
                        <div class="type-bar" *ngIf="course.structure.name" [ngClass]='course.structure.name.replace(" ","-").toLowerCase()'></div>

                        <div class="font-weight-bold">
                            <div class="pull-right">{{course.id}}</div>
                            {{course.region.name}}
                        </div>

                        <div *ngIf="course.landingPageImage" class='landing-page-image'>
                            <img [src]='course.landingPageImage.large' />
                        </div>

                        <div class='course font-weight-bold' style='margin-top:1.0em; font-size:2.0em;'>{{course.name}}</div>

                        <div *ngIf="!showVendors">
                            <div style='margin-top:1.0em;'>
                                {{course.startDate | date:"EEEE, MMMM d, y h:mm:ss a"}}
                                <span *ngIf="isOneDayEvent && course.endDate"> - {{course.endDate | date:"h:mm:ss a"}}</span>
                                <span *ngIf="!isOneDayEvent && course.endDate"> - {{course.endDate | date:"EEEE, MMMM d, y h:mm:ss a"}}</span>
                            </div>

                            <div class="pull-right" style='margin-left:1.5em;' *ngIf="course.joinUrl">
                                <app-presentation-button [isActive]="true" (click)="open(course.joinUrl)">Join</app-presentation-button>
                            </div>

                            <div style='margin-top:1.5em;' *ngIf="course.welcomeMessage" [innerHTML]="course.welcomeMessage"></div>
                            
                            <div class="clearfix"></div>

                            <div style='margin-top:2.0em;'>
                                <app-landing-page-course-sessions [course]='course'></app-landing-page-course-sessions>
                            </div>

                        </div>

                        <div style='margin-top:2.0em;'>
                            <app-landing-page-course-vendors [course]='course'></app-landing-page-course-vendors>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <pre>{{course|json}}</pre> -->